import * as React from "react";
import { Router } from "@reach/router";

import PageHeader from '../common/PageHeader';
import Verify21Modal from '../home/Verify21Modal'; 
import PageFooter from '../common/PageFooter';
import PageLayout from '../layout/PageLayout';
import ModalProvider from '../modal/ModalProvider';
import DispensariesProvider from "../dispensaries/DispensariesProvider";
import ProductCategoryProvider from "../productCategory/ProductCategoryProvider";
import DispensaryProvider from "../dispensary/DispensaryProvider";
import NotificationsProvider from "../notifications/NotificationsProvider";
import OrderProvider from "../orders/OrderProvider";
import ReOrderDetails from "../orders/ReOrderDetails";
import OrderConfirmation from '../orderConfirmation/OrderConfirmation';
import PlaceOrderController from '../viewControllers/PlaceOrderController';
import DispensariesController from '../viewControllers/DispensariesController';
import DispensaryWithNewContext from '../dispensary/DispensaryWithNewContext';
import SwitchDispensary from '../dispensaries/SwitchDispensary';
import SignIn from "../registration/SignIn";
// New inline SignUpPage replaces lagacy reg flow
import SignUpPage from "../registration/SignUpPage";
import EmailSignUpController from "../viewControllers/EmailSignUpController";
import PrintSignUpController from "../viewControllers/PrintSignUpController";
import SignUpRoutes from "../registration/SignUpRoutes";
import RegistrationProvider from "../registration/RegistrationProvider";
import GuestCheckoutProvider from "../checkoutUserFlow/GuestCheckoutProvider";
import GetReferralCode from '../refer/GetReferralCode';
import AcceptReferralCode from '../refer/AcceptReferralCode';
import EmailResponseController from '../emailRequest/EmailResponseController';
import Home from '../home/Home';
import ProductDetailWithContext from '../products/ProductDetailWithContext';
import ShopByProduct from '../productCategory/ShopByProduct';
import TestLinks from '../testing/TestLinks';
import PunchList from '../home/PunchList';
import PageNotFound from '../common/PageNotFound';
import AllProducts from '../products/AllProducts';
import UpdateProducts from '../products/UpdateProducts';
import ProductDetail from '../products/ProductDetail';
import LinkAccountsCallout from '../payment/LinkAccountsCallout';
import FramableLocationSearch from '../address/FramableLocationSearch';
import Preview from '../preRegister/Preview';
import ProtectedRoutes from './ProtectedRoutes';

const GatedSite = () => {
  return (
    <DispensariesProvider>
      <ProductCategoryProvider>
      <DispensaryProvider>
      <OrderProvider>   
      <NotificationsProvider>
      <RegistrationProvider>
      <GuestCheckoutProvider>   
        <PageLayout>
          <ModalProvider>
            <PageHeader />
            <Verify21Modal />
            <Router>
              {/* START Reg Flow */}
              <SignUpRoutes path="/signUp/*" />
              {/* END Reg Flow */}
              {/* Single page signup */}
              <SignUpPage path="/register" />
              <EmailSignUpController path="/emailSignUp" />
              {/* LOWERCASE! used for print campaigns */}
              <PrintSignUpController path="/signup" /> 
              <Home path="/" exact />
              <DispensariesController path="/dispensaries" />
              <DispensaryWithNewContext path="/dispensary/:dispensaryId" />
              <DispensaryWithNewContext path="/dispensary/:dispensaryId/:productCategoryName" />
              <SwitchDispensary path="/switchDispensary/:dispensaryId" />
              <ProductDetailWithContext path="/dispensaryProduct/:dispensaryId/:itemId" />
              <OrderConfirmation path="/orderConfirmation" />
              <ReOrderDetails path="/reorder/:orderId" />
              <PlaceOrderController path="/placeOrder/:dispensaryId" />
              <GetReferralCode path="/referralCode" />
              <AcceptReferralCode path="/refer/:referCode" />
              <SignIn path="/signIn" />
              <EmailResponseController path="/emailResponse" />
              <PunchList path="/punchlist" />
              <TestLinks path="/test" />
              <AllProducts path="/allProducts" />
              <AllProducts path="/allProducts/:dispensaryId" />
              <UpdateProducts path="/updateProducts/:dispensaryId" />
              <ProductDetail path="/productDetail/:productId" />
              <ShopByProduct path="/shopByProduct" />
              <ShopByProduct path="/shopByProduct/:productCategory" />
              <LinkAccountsCallout path="/link" />
              <Preview path="/preview" />
              <FramableLocationSearch path="/framableLocationSearch" />
              {/* /your/account and /your/orders */}
              <ProtectedRoutes path="/your/*" />
              <PageNotFound default />
            </Router>
            <PageFooter />
          </ModalProvider>
        </PageLayout>
      </GuestCheckoutProvider>   
      </RegistrationProvider>
      </NotificationsProvider>
      </OrderProvider>
      </DispensaryProvider>
      </ProductCategoryProvider>
    </DispensariesProvider>  
  ); 
}

export default GatedSite;